export class MonitorItem {
    public Id: number;
    public MonitorId: number;
    public ConfigurationId: number;
    public MonitorItemName: string;
    public FocusMode: number;
}
